import {ReactSearchAutocomplete} from "react-search-autocomplete";
import React from "react";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";

const AutoComplete = (props) => {

    const isDarkMode = useSelector((state) => state.customizer.isDark);

    const {searchItems, handleOnSelect, handleOnClear} = props;

    return (
        <ReactSearchAutocomplete
            items={searchItems}
            fuseOptions={{keys: ["name"]}} // Search on both fields
            resultStringKeyName="name" // String to display in the results
            onSelect={handleOnSelect}
            onClear={handleOnClear}
            showIcon={false}
            styling={{
                height: "34px",
                border: "1px solid grey",
                borderRadius: "4px",
                backgroundColor: isDarkMode ? "#192430" : "white",
                boxShadow: "none",
                hoverBackgroundColor: isDarkMode ? "#303a45" : "lightgrey",
                color: isDarkMode ? "white" : "black",
                fontSize: "13px",
                clearIconMargin: "3px 8px 0 0",
                zIndex:1
            }}
        />
    )
}

AutoComplete.propTypes = {
    searchItems: PropTypes.array,
    handleOnSelect: PropTypes.func,
    handleOnClear: PropTypes.func,
};

export default AutoComplete;